import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const QueuesVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "v1.0/Queues",
    $_Queues: [],
    $_currentQueues: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    allQueues: state => state.$_Queues,
    currentQueues: state => state.$_currentQueues,
    actionState: state => state.$_actionState,
    errorState: state => state.$_errorState
  },
  actions: {
    initQueues({ commit }) {
      var queues = {
        id: 0,
        name: "",
        description: "",
        host: "",
        port: 0,
        virtualHost: "",
        credentials: "",
        persistent: false,
        isActive: false
      };

      commit("SET_QUEUE", queues);
    },
    clearQueues({ commit }) {
      commit("SET_QUEUES", []);
    },
    setQueue({ commit }, queues) {
      commit("SET_QUEUE", queues);
    },
    async getQueues({ commit, dispatch, state, rootGetters }) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_QUEUES", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getQueue({ commit, dispatch, state, rootGetters }, id) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_QUEUE", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async createQueue(
      { commit, dispatch, state, rootGetters },
      queues
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        queues.id = 0;
        const response = await axios.post(
          actionLink,
          queues,
          axiosConfig
        );
        queues.id = response.data.id;
        commit("SET_QUEUE", queues);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async updateQueue(
      { commit, dispatch, state, rootGetters },
      data
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.put(
          actionLink,
          data.queues,
          axiosConfig
        );
        data.queues.id = response.data.id;

        commit("SET_QUEUE", data.queues);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_QUEUES(state, value) {
      state.$_Queues = value;
    },
    SET_QUEUE(state, value) {
      state.$_currentQueues = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default QueuesVuexModule;
